import React from 'react';
import { buildInsightChips } from '../../utils/injuryReportHeuristics';

const CHIP_STYLES = {
	high_impact:
		'bg-yellow-50 text-yellow-900 ring-1 ring-yellow-200 dark:bg-yellow-900 dark:bg-opacity-40 dark:text-yellow-100 dark:ring-yellow-800',
	qb_tether:
		'bg-red-50 text-red-800 ring-1 ring-red-200 dark:bg-red-900 dark:bg-opacity-40 dark:text-red-100 dark:ring-red-900',
	on_roster:
		'bg-blue-50 text-blue-800 ring-1 ring-blue-200 dark:bg-blue-900 dark:bg-opacity-40 dark:text-blue-100 dark:ring-blue-900',
	high_exposure:
		'bg-indigo-50 text-indigo-800 ring-1 ring-indigo-200 dark:bg-indigo-900 dark:bg-opacity-40 dark:text-indigo-100 dark:ring-indigo-900',
	ir_return_timeline:
		'bg-gray-100 text-gray-700 ring-1 ring-gray-200 dark:bg-dark-border dark:text-dark-text dark:ring-dark-border'
};

export default function InjuryReportInsightChips({ player }) {
	const chips = buildInsightChips(player);

	if (!chips.length) {
		return <span className="text-xs text-gray-300 dark:text-gray-600">—</span>;
	}

	return (
		<div className="flex flex-wrap gap-1.5">
			{chips.map((chip) => (
				<span
					key={`${player.id}-${chip.key}`}
					title={chip.tooltip || chip.label}
					className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${
						CHIP_STYLES[chip.key] ||
						'bg-gray-50 text-gray-600 ring-1 ring-gray-200 dark:bg-dark-border dark:text-dark-text'
					}`}
				>
					{chip.label}
				</span>
			))}
		</div>
	);
}
